import {Test} from 'lib/test'
import * as React from 'react'
import {CircularProgressBar} from "app/Components/ProgressBar";
import {LFWForm} from "./LFWForm";

type PreviewProps = {
    test: Test
}

export class LFWRawData extends React.Component<PreviewProps> {
    public render = () => <>
        {this.props.test && this.props.test.content ?
            <LFWForm data={this.props.test.content.data} preview={true} /> : <CircularProgressBar/>
        }
    </>
}